<template>
  <div class="myBody">
    <div class="myTitle">
      <img src="../assets/u89.svg" alt="" />
      <div class="t1">网页端</div>
      <div class="t2">海量财经领域文本大数据，无需下载，在线获取</div>
      <div class="myButton" @click="toIndex">立即使用</div>
    </div>
    <div class="myContent">
      <div class="cL">
        <img src="../assets/u0.png" alt="" />
        <div class="cLT">文本数据</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('文本数据.mp4')"
          src="../assets/文本图 视频_1.jpg"
        />
        <div class="t3">文本数据</div>
        <div class="t4">指导如何查询文本数据</div>
      </div>
    </div>
    <div class="myTitle">
      <img src="../assets/u83.svg" alt="" />
      <div class="t1">客户端</div>
      <div class="t2" style="margin-right: 370px">
        智能文本分析系统，本地处理文本，更强大的自定义文本处理功能
      </div>
      <div class="myButton" @click="DownLoadClient">立即下载</div>
    </div>
    <div class="myContent">
      <div class="cL">
        <img src="../assets/u0.png" alt="" />
        <div class="cLT">自由搜索</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('自定义文件夹.mp4')"
          src="../assets/文本图 视频_1 副本.jpg"
        />
        <div class="t3">自定义文件夹</div>
        <div class="t4">带你快速上手爱文本系统</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('系统文本.mp4')"
          src="../assets/文本图 视频_1 副本 2.jpg"
        />
        <div class="t3">系统文本</div>
        <div class="t4">指导如何获取系统文本信息</div>
      </div>
    </div>
    <div class="myContent">
      <div class="cL">
        <img src="../assets/u0.png" alt="" />
        <div class="cLT">文本分析</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('基本信息.mp4')"
          src="../assets/文本图 视频_1 副本 3.jpg"
        />
        <div class="t3">基本信息</div>
        <div class="t4">带你快速掌握文本基本信息</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('情感分析.mp4')"
          src="../assets/文本进行情感分析.png"
        />
        <div class="t3">情感分析</div>
        <div class="t4">指导如何对文本进行情感分析</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('可读性分析.mp4')"
          src="../assets/文本图 视频_1 副本 5.jpg"
        />
        <div class="t3">可读性分析</div>
        <div class="t4">指导如何分析文本可读性</div>
      </div>
    </div>
    <div class="myContent">
      <div class="cL">
        <img src="../assets/u0.png" alt="" />
        <div class="cLT">文本预处理</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('数据读取.mp4')"
          src="../assets/文本图 视频_1 副本 6.jpg"
        />
        <div class="t3">数据读取</div>
        <div class="t4">教您快速准确地读入数据</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('分词、去停用词、特征词库.mp4')"
          src="../assets/文本图 视频_1 副本 7.jpg"
        />
        <div class="t3">分词、去停用词、特征词库</div>
        <div class="t4">教您如何使用分词功能</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('文本向量化.mp4')"
          src="../assets/文本图 视频_1 副本 8.jpg"
        />
        <div class="t3">文本向量化</div>
        <div class="t4">教您快速实现文本向量化处理</div>
      </div>
    </div>
    <div class="myContentjixuexi">
      <div class="cL">
        <img src="../assets/u0.png" alt="" />
        <div class="cLT">机器学习</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('相似度计算.mp4')"
          src="../assets/计算文本相似度.png"
        />
        <div class="t3">相似度计算</div>
        <div class="t4">教您快速计算文本相似度</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('文本分类.mp4')"
          src="../assets/文本图 视频_1 副本 10.jpg"
        />
        <div class="t3">文本分类</div>
        <div class="t4">教您如何对文本进行分类分析</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('文本聚类.mp4')"
          src="../assets/文本图 视频_1 副本 11.jpg"
        />
        <div class="t3">文本聚类</div>
        <div class="t4">教您掌握文本聚类方法</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('主题模型.mp4')"
          src="../assets/文本图 视频_1 副本 12.jpg"
        />
        <div class="t3">主题模型</div>
        <div class="t4">教您在文本中挖掘主题模型</div>
      </div>

      <div class="cR" style="margin-left: 130px; margin-top: 50px">
        <img @click="playVideo('Word2Vec.mp4')" src="../assets/Word2vec.png" />
        <div class="t3">Word2Vec</div>
        <div class="t4">教您如何使用Word2Vec</div>
      </div>
    </div>
    <div class="myContent" style="margin-top: 300px">
      <div class="cL">
        <img src="../assets/u0.png" alt="" />
        <div class="cLT">大语言模型</div>
      </div>
      <div class="cR">
        <img
          @click="playVideo('大语言模型.mp4')"
          src="../assets/零代码大语言模型.png"
        />
        <div class="t3">大语言模型</div>
        <div class="t4">零代码操作Bert和ERNIE</div>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="70%"
      destroy-on-close
    >
      <video
        v-if="control"
        controls
        style="width: 100%; height: 100%; padding-top: 10px"
        controlsList="nodownload"
        :src="
          'https://wordwise.oss-cn-shanghai.aliyuncs.com/aitextsvideo/' +
          currentVideo
        "
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "operateVideo",
  data() {
    return {
      dialogVisible: false,
      currentVideo: "",
      // control: false
    };
  },
  methods: {
    playVideo(val) {
      this.currentVideo = val;
      this.dialogVisible = true;
      this.control = true;
      setTimeout(() => {
        $("video").bind("contextmenu", function () {
          return false;
        });
      }, 100);
    },
    DownLoadClient() {
      // window.open(
      //   "https://jinghe-picture.oss-cn-shanghai.aliyuncs.com/aitextclient%2F%E7%88%B1%E6%96%87%E6%9C%AC%E5%AE%A2%E6%88%B7%E7%AB%AF1.0.81Setup.exe"
      // );
      // this.modalDownload = false;

      axios
        .get("/api/register/getDownloadAitextClient")
        .then((res) => {
          if (res.status === 200) {
            window.open(res.data.data);
          }
        })
        .catch((e) => {
          console.warn(e);
        });
    },
    toIndex() {
      this.$router.push({ path: "/gsgg" });
    },
    // handleClose(done) {
    //   this.control = false
    //   this.dialogVisible = false;

    //   done();
    // },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.myBody {
  height: 2080px;

  .myTitle {
    display: flex;
    height: 84px;
    width: 1200px;
    margin: 30px auto;
    line-height: 84px;
    border: 1px solid #e6eaf2;
    border-radius: 20px;
    padding: 0 20px;

    img {
      width: 30px;
      height: 20px;
      margin-top: 32px;
      margin-right: 30px;
    }

    .t1 {
      font-size: 26px;
      color: #262d3d;
      font-family: "Arial Normal", "Arial", sans-serif;
      font-weight: 400;
      margin-right: 30px;
    }

    .t2 {
      font-size: 16px;
      color: #78849e;
      font-family: "Arial Normal", "Arial", sans-serif;
      font-weight: 400;
      margin-right: 500px;
    }

    .myButton {
      width: 130px;
      height: 34px;
      line-height: 34px;
      margin-top: 23px;
      text-align: center;
      border: 1px solid #e6eaf2;
      border-radius: 5px;
      cursor: pointer;
    }
  }

  .myContent {
    display: flex;
    height: 210px;
    width: 1200px;
    margin: 50px auto;

    .cL {
      position: relative;

      img {
        width: 100px;
        height: 100px;
      }

      .cLT {
        position: absolute;
        width: 70px;
        top: 15px;
        left: 25px;
        font-weight: 700;
        font-style: normal;
        font-size: 25px;
        color: #333;
        line-height: 36px;
      }
    }

    .cR {
      cursor: pointer;
      margin-left: 30px;
      transition: 0.2s;

      img {
        width: 245px;
        height: 138px;
      }

      .t3 {
        font-weight: 700;
        font-style: normal;
        font-size: 17px;
        text-align: left;
        line-height: 24px;
        margin-top: 15px;
        margin-left: 10px;
      }

      .t4 {
        font-family: "Microsoft YaHei", sans-serif;
        font-weight: 400;
        font-style: normal;
        color: #999999;
        text-align: left;
        line-height: 18px;
        margin-top: 5px;
        margin-left: 10px;
      }
    }

    .cR:hover {
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
    }
  }

  .myContentjixuexi {
    display: flex;
    flex-wrap: wrap;
    height: 210px;
    width: 1200px;
    margin: 50px auto;

    .cL {
      position: relative;

      img {
        width: 100px;
        height: 100px;
      }

      .cLT {
        position: absolute;
        width: 70px;
        top: 15px;
        left: 25px;
        font-weight: 700;
        font-style: normal;
        font-size: 25px;
        color: #333;
        line-height: 36px;
      }
    }

    .cR {
      cursor: pointer;
      margin-left: 30px;
      transition: 0.2s;

      img {
        width: 245px;
        height: 138px;
      }

      .t3 {
        font-weight: 700;
        font-style: normal;
        font-size: 17px;
        text-align: left;
        line-height: 24px;
        margin-top: 15px;
        margin-left: 10px;
      }

      .t4 {
        font-family: "Microsoft YaHei", sans-serif;
        font-weight: 400;
        font-style: normal;
        color: #999999;
        text-align: left;
        line-height: 18px;
        margin-top: 5px;
        margin-left: 10px;
      }
    }

    .cR:hover {
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
    }
  }
}
</style>